module.exports = __webpack_public_path__ + "images/_/assets/images/popup-open.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup-open.png
// module id = ./src/assets/images/popup-open.png
// module chunks = 1